"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PredefinedRoute = exports.NavUrl = void 0;
var reconnect_js_1 = require("reconnect.js");
var query_string_1 = __importDefault(require("query-string"));
var PredefinedRoute;
(function (PredefinedRoute) {
  PredefinedRoute["profile"] = "/profile";
  PredefinedRoute["checkout"] = "/checkout";
  PredefinedRoute["checkoutInfo"] = "/checkout/info";
  PredefinedRoute["mobileCheckoutInfo"] = "/mobile/checkout/info";
  PredefinedRoute["checkoutReview"] = "/checkout/review";
  PredefinedRoute["mobileCheckoutReview"] = "/mobile/checkout/review";
  PredefinedRoute["products"] = "/products";
})(PredefinedRoute || (PredefinedRoute = {}));
exports.PredefinedRoute = PredefinedRoute;
var NavUrl = /** @class */function () {
  function NavUrl(baseUrl, params) {
    if (params === void 0) {
      params = {};
    }
    this.baseUrl = baseUrl;
    this.params = params;
  }
  NavUrl.from = function (predefinedRoute, params) {
    if (params === void 0) {
      params = {};
    }
    var hasRouteOutlet = reconnect_js_1.hasOutlet('routes');
    if (hasRouteOutlet) {
      var routeConfig = reconnect_js_1.getOutlet('routes').getValue();
      var customRoute = typeof routeConfig.getRoute === 'function' ? routeConfig.getRoute(predefinedRoute, params) : null;
      if (customRoute) {
        var _a = query_string_1.default.parseUrl(customRoute),
          url = _a.url,
          query = _a.query;
        var navUrl = new NavUrl(url, query);
        return navUrl;
      }
    }
    return new NavUrl(predefinedRoute, params);
  };
  NavUrl.prototype.toString = function () {
    var url = query_string_1.default.stringifyUrl({
      url: this.baseUrl,
      query: this.params
    });
    return url;
  };
  return NavUrl;
}();
exports.NavUrl = NavUrl;
exports.default = NavUrl;